module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticStyle: {
      "font-family": "'Roboto Thin'",
      "font-size": "16px",
      "padding-bottom": "3px",
      "padding-right": "5px",
      "margin-bottom": "15px",
      "border-bottom": "solid 1px #ddd",
      "float": "left"
    }
  }, [_vm._v("\n    Редактирование задачи\n  ")]), _vm._v(" "), (_vm.editingTask != null) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "font-family": "'Roboto Thin'",
      "font-size": "16px",
      "padding-bottom": "5px",
      "float": "left"
    }
  }, [_vm._v("\n      Задача:\n      "), _c('Input', {
    ref: "taskname",
    staticStyle: {
      "width": "585px"
    },
    attrs: {
      "size": "large"
    },
    on: {
      "on-blur": function($event) {
        _vm.nameOnBlur()
      }
    },
    model: {
      value: (_vm.editingTask.name),
      callback: function($$v) {
        _vm.editingTask.name = $$v
      },
      expression: "editingTask.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "30px 0px 0px 0px",
      "width": "100%",
      "float": "left"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.saveOnClick
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.cancelOnClick
    }
  }, [_vm._v("Отменить")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "text",
      "disabled": ""
    },
    on: {
      "click": _vm.archiveOnClick
    }
  }, [_vm._v("Архивировать")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.deleteOnClick
    }
  }, [_vm._v("Удалить")])], 1)]) : _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding-top": "10px",
      "padding-bottom": "20px",
      "float": "left"
    }
  }, [_vm._v("* нет задачи для редактирования ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tasks"
    }
  }, [_vm._v("Вернуться к списку задач")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2597e032","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskEdit.vue
// module id = 394
// module chunks = 0